import React from 'react';
import { withRouter } from 'react-router-dom';

import { AuthContext, UserContext } from '@shared/contexts';
import { PAGE_KEYS } from '@shared/constants';
import { decodeToken, setPageConfig } from '@utils';

function getCookie(key) {
  var b = document.cookie.match('(^|;)\\s*' + key + '\\s*=\\s*([^;]+)');
  return b ? b.pop() : '';
}

export default withRouter(({ history, location }) => {
  const { setAuth } = React.useContext(AuthContext);
  const { setUserData } = React.useContext(UserContext);

  const params = new URLSearchParams(location.search);
  const access_token = getCookie('access_token');
  const returnurl = params.get('returnurl');

  if (access_token && access_token.length > 0) {
    const decodedData = decodeToken(access_token);
    setUserData(decodedData.rc_access_token);
    setAuth(access_token);
    setPageConfig(PAGE_KEYS.GLOBAL, {
      theme: 'light',
    });
    localStorage.setItem('rcAccountId', decodedData.rcuser_uid);
    window.location.replace(returnurl);
  } else {
    history.push('/');
  }

  return null;
});
